export default __webpack_public_path__ + "7dcfd4257f3d876c0d36151da23a3b76.png";